import { Info } from "lucide-react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

import { sourceDescription, sourceLabel } from "./stats-format";

/** A source's name with an info mark; hovering (or focusing) it says what the source means. */
export function SourceName({ source }: { source: string | null }) {
  const description = sourceDescription(source);
  return (
    <span className="inline-flex items-center gap-1.5">
      <span>{sourceLabel(source)}</span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              data-nonmutating
              aria-label={`What ${sourceLabel(source)} means: ${description}`}
              className="text-muted-foreground hover:text-ks-purple"
            >
              <Info aria-hidden className="size-3.5" />
            </button>
          </TooltipTrigger>
          <TooltipContent>{description}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </span>
  );
}
